// Copyright (c) 2025. CYBERKOALA LLC. All Rights Reserved.
// Proprietary license.

import { createContext } from 'react';

export const SocketContext = createContext<WebSocket | null>(null);
